import React, { useContext } from 'react';
import styled from '@emotion/styled';
import { MEDIA_QUERY } from '@zola/zola-ui/src/styles/emotion';
import {
  mapFontViewToSerializedStyles,
  mapPseudoElementToCSS,
} from 'components/publicWebsiteV2/util/mappers';
import { ThemeContext } from '../../../../context';
import { renderAbsoluteAssets } from '../../../../util/renderHelpers';

type NamesModulesProps = {
  ownerFirstName?: string;
  ownerLastName?: string;
  partnerFirstName?: string;
  partnerLastName?: string;
  className?: string;
};

const NamesModule = ({
  ownerFirstName,
  ownerLastName,
  partnerFirstName,
  partnerLastName,
  className,
}: NamesModulesProps): JSX.Element => {
  const {
    components: { H2, H4 },
    homepage: {
      name: { and_display, assets },
    },
  } = useContext(ThemeContext);
  const { before, after, arrange } = assets?.inFlow || {};

  const displayStyle = `display: ${arrange === 'horizontal' ? 'inline-block' : 'block'}`;

  const Container = styled.div`
    padding-top: 90px;
    ${MEDIA_QUERY.EXCLUDE_DESKTOP} {
      padding-top: 10px;
    }
    display: flex;
    align-items: center;
    justify-content: space-around;
    text-align: center;

    width: 100%;
    ${displayStyle};
    position: relative;

    &:before {
      ${displayStyle};
      margin-left: auto;
      margin-right: auto;
      vertical-align: middle;
      position: relative; // ALLOW OFFSET?
      ${mapPseudoElementToCSS(before)}
    }

    &:after {
      ${displayStyle};
      margin-left: auto;
      margin-right: auto;
      vertical-align: middle;
      ${mapPseudoElementToCSS(after)}
    }
  `;

  // OTOD: CONTENT WIDTH CONSTATNS
  const ContentContainer = styled.div`
    max-width: 800px;
    display: inline-flex;
    align-items: center;
    vertical-align: middle;

    ${MEDIA_QUERY.MOBILE} {
      flex-direction: column;
    }
  `;

  const Name = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 30%;
  `;

  const And = styled(H4)`
    margin: 0 32px;
    flex-grow: 1;
    ${MEDIA_QUERY.MOBILE} {
      margin: 20px 0;
    }

    ${and_display?.font ? mapFontViewToSerializedStyles(and_display.font) : ''}
  `;

  return (
    <>
      {renderAbsoluteAssets(assets)}
      <Container className={className}>
        <ContentContainer>
          <Name>
            <H2>{ownerFirstName}</H2>
            <H2>{ownerLastName}</H2>
          </Name>
          <And>{and_display?.content || 'and'}</And>
          <Name>
            <H2>{partnerFirstName}</H2>
            <H2>{partnerLastName}</H2>
          </Name>
        </ContentContainer>
      </Container>
    </>
  );
};

export default NamesModule;
